var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.75V14.25C13.3333 17.1667 12.1667 18.3333 9.25 18.3333H5.75C2.83333 18.3333 1.66667 17.1667 1.66667 14.25V10.75C1.66667 7.83334 2.83333 6.66667 5.75 6.66667H9.25C12.1667 6.66667 13.3333 7.83334 13.3333 10.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 1.66667H10.75C8.18076 1.66667 6.97581 2.57841 6.72478 4.78252C6.67227 5.24363 7.05416 5.62501 7.51825 5.62501H9.25C12.75 5.62501 14.375 7.25 14.375 10.75V12.4818C14.375 12.9458 14.7564 13.3277 15.2175 13.2752C17.4216 13.0242 18.3333 11.8192 18.3333 9.25001V5.75001C18.3333 2.83334 17.1667 1.66667 14.25 1.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.bad4932747bf1d06bdf1da0921563925.svg";
export { ForwardRef as ReactComponent };